import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
	
		/* 用户登录凭证 */
		token: '',
		/* 用户信息 */
		_user: {},
		// 登录对话框显示状态
		_loginDialogStatus: {
			visible: false,
			type: 'account',
		  },
		
		
	},
	getters: {	
        user(state){
            return state._user;
        },
		// 用户是否登录
		isLogin(state) {
			return state.token;
        },   
		// 用户是否登录
		isLogin(state) {
			return state._user.id ? true : false;
		},
		loginDialogStatus(state) {
			return state._loginDialogStatus;
		},
	},
	mutations: {
		/* 设置客户端宽度 */
		setClientWidth(state, width) {
			state.clientWidth = width;
		},
		/* 设置token */
		setToken(state, token) {
			state.token = token;
		},
		/* 设置用户信息 */
		setUser(state, user) {
			state._user = user;
        },
        /*
        *   设置user单个属性
         */
        setUserByKey(state,data){
            for(var key in data){
                state._user[key] = data[key];
            }
        },
		/* 将token写入cookie */
		setTokenInCookie(state, token) {
			if (['localhost', '127.0.0.1'].includes(window.location.hostname)) {
				Vue.prototype.$cookies.set('token', token, -1, '/', window.location.hostname);
			} else {
				let host = window.location.hostname.split('.');
				Vue.prototype.$cookies.set('token', token, -1, '/', `.${host[1]}.${host[2]}`);
			}
		},
		/* 将token从cookie中移除 */
		removeTokenInCookie() {
            
			if (['localhost', '127.0.0.1'].includes(window.location.hostname)) {
				Vue.prototype.$cookies.remove('token', '/', window.location.hostname);
			} else {
				let host = window.location.hostname.split('.');
				Vue.prototype.$cookies.remove('token', '/', `.${host[1]}.${host[2]}`);
			}
        },
		// 显示登录对话框
		showLoginDialog(state, type = 'account') {
			state._loginDialogStatus.type = type;
			state._loginDialogStatus.visible = true;
		},
		// 设置登录对话框显示状态
		setLoginDialogVisible(state, status) {
			state._loginDialogStatus.visible = status;
		  },
		  // 设置登录对话框类型
		  setLoginType(state, type) {
			state._loginDialogStatus.type = type;
		  },
	},
	actions: {
		// 登录
		login({ commit }, {token ,user}) {
		
			// 设置全局token
			commit('setTokenInCookie', token);

			commit('setUser',user);
		}, // 退出登录
		logout({ commit }) {
			
			// 清除token值
			commit('removeTokenInCookie');
			// 清空用户信息
			commit('setUser', {});
        },
		userAddProperty({commit},data){
			commit('setUserByKey', data);
		}	
	},
});

export default store;